/**
 * label di tutte le pagine, ogni oggetto si riferisce ad una pagina dell'applicazione
 */

const LAYOUT = {
  DARK_MODE: (isActive) => `${isActive ? "Disa" : "A"}ttiva la modalità Notte`,
  LOGOUT: "Logout",
  NET4MARKET: "Net4market - CSAmed s.r.l.",
  MANUALE: "Leggi il manuale d'uso",
};

const TOAST = {
  AUTHENTICATION_ERROR: "Username o password errati",
  BLOCKED_USER_ERROR:
    "Utente non abilitato al servizio di personalizzazione dei pasti",
  SESSION_EXPIRE_WARNING:
    "La sessione sta per scadere, salva le modifiche e rieffettua il login",
  MAX_PLATE_SAVING_WARN:
    "È stato selezionato un numero di piatti non consentito",
  NO_CHANGES_WARN: "Non ci sono modifiche da salvare",
  MAX_PLATE_ERROR: "Hai già selezionato il numero massimo di piatti",
  GENERIC_ERROR: "Si è verificato un errore imprevisto",
  SAVED: "Portata aggiornata con successo",
};

const ERRORI = {
  PREFIX: "Errore",
  OPS: "OPS",
  NOT_FOUND: "La pagina che cerchi non esiste",
  GENERIC_ERROR: "si è verificato un errore imprevisto",
  OPERATION_NOT_ALLOWED: "operazione non consentita",
  AUTHENTICATION_ERROR: "errore nell'autenticazione",
  BACK_TO_REQUESTS: "Torna alle richieste",
  TRY_AGAIN: "Riprova",
};

const LOGIN = {
  INPUT_BRACELET_PLACEHOLDER: "utente",
  INPUT_PASSWORD_PLACEHOLDER: "password",
  ACCESS_BTN: "Accedi",
  CARD_TITLE: "Accesso al sistema prenotazione pasti",
  HOSPITAL_NAME: "Azienda Ospedaliero-Universitaria di Bologna IRCCS",
};

const RICHIESTE = {
  MODIFY_REQUEST: "Modifica",
  CARD_TITLE: "Seleziona richiesta",
  NO_REQUESTS: "Non sono presenti richieste da modificare",
  WELCOME: (codFis) => `Benvenut${codFis ? defineMorF(codFis) : "o/a"}!`,
};

/**
 * Il metodo definisce se l'utente è un uomo o una donna e ritorna la vocale per il benvenuto
 * @param {String} codFis Codice fiscale dell'utente
 * @returns 'o' se l'utente è un uomo, 'a' se si tratta di una donna
 */
const defineMorF = (codFis) =>
  parseInt(codFis.substring(9, 11)) <= 31 ? "o" : "a";

const RICHIESTA = {
  PAGE_TITLE: (date) => `Richiesta del ${date}`,
  MEAL_CHOISE: "Scegli pasto",
  MEAL_CHOISE_TITLE: "Seleziona pasto",
  VIEW_MEAL: "Visualizza",
  CHANGE_MEAL: "Cambia",
  CHOOSE_MEAL: "Scegli",
  FASTING: "Digiuno",
  LAST_EDIT: (who, date) =>
    `Modificato da ${who} il ${date.data} alle ${date.ora}`,
  DEPARTMENT: "Reparto",
  PATIENT: "Paziente",
  NOT_EDITABLE: (dietaPersonalizzata) =>
    `Pasto non modificabile, ${
      dietaPersonalizzata
        ? " gestito dal servizio dietetico"
        : "limite orario superato"
    }`,
  FASTING_ON: (date) =>
    `Messo a digiuno da Reparto il ${date.data} alle ${date.ora}`,
  REQUESTS: "Richieste",
  MEAL_NOT_SET: (meal) => `${meal} non scelt${defineGeneralPlural(meal)}`,
};

const PORTATA = {
  PAGE_TITLE: (meal, date) => `${meal} del ${date}`,
  CARD_SUBTITLE: (maxPlate) =>
    `${maxPlate} scelt${defineEorA(maxPlate)} massim${defineEorA(maxPlate)}`,
  ALLERGENS_TITLE: (plate) => `Allergeni: ${plate}`,
  ALLERGENS_LABEL: "A",
  SELECTED_CHECKBOX: "Selezionato",
  REQUIRED_CHECKBOX: "Obbligatorio",
  NOT_SELECTED_CHECKBOX: "Seleziona",
  SAVE: "Salva",
  CANCEL: "Annulla",
  BACK: "Indietro",
};

/**
 * Il metodo definisce la vocale finale per la label che indica il numero di piatti selezionabili dall'utente
 * @param {Number} maxPlate Numero massimo di piatti selezionabili
 * @returns 'e' se il numero è maggiore di 1, 'a' se la condizione non è verificata
 */
const defineEorA = (maxPlate) => (maxPlate > 1 ? "e" : "a");

const defineGeneralPlural = (meal) =>
  getLastChar(meal.split(" ")[0]) === "a" ? "a" : "i";
const getLastChar = (word) => word[word.length - 1];

export default {
  LAYOUT,
  TOAST,
  ERRORI,
  LOGIN,
  RICHIESTE,
  RICHIESTA,
  PORTATA,
};
